import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/cn";

const bannerVariants = cva("rounded-md border p-3 text-sm", {
  variants: {
    variant: {
      info: "border-info/20 bg-info/10 text-info-foreground",
      success: "border-success/20 bg-success/10 text-success-foreground",
      warning: "border-warning/20 bg-warning/10 text-warning-foreground",
      error: "border-destructive/20 bg-destructive/10 text-destructive",
    },
  },
  defaultVariants: {
    variant: "info",
  },
});

export interface BannerProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof bannerVariants> {}

function Banner({ className, variant, ...props }: BannerProps) {
  return <div className={cn(bannerVariants({ variant }), className)} {...props} />;
}

export { Banner };
